import Vue from 'vue';

export const eventBus = new Vue();

export enum EventType {
  SECTION_MADE_PROGRESS = 'section-made-progress',
  SECTION_COMPLETED = 'section-completed',
}
